import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ProfileSecurityComponent from './security.component';

const profileSecurityModule = angular.module('tinaba.components.profile.security', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('profile.security', {
      url: '/security',
      template: '<profile-security></profile-security>'
    });
})

.component('profileSecurity', ProfileSecurityComponent);

export default profileSecurityModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/security/security.js
 **/